import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { window } from "@swa-ui/browser";
import { classNames } from "@swa-ui/string";

import { PortalRoot } from "../PortalRoot";
import styles from "./CenterToWindow.module.scss";

/**
 * Centers the given children content in the viewport/window.
 */
export const CenterToWindow = (props) => {
  const { children, fixed, location = "hidden", overlayClassName } = props;
  const [yOffset, setYoffset] = useState();

  useEffect(() => {
    setYoffset(window.scrollY);
  }, [window.scrollY]);

  return yOffset !== undefined ? (
    <PortalRoot className={getClass()}>
      <div {...getTargetProps()}>{children}</div>
    </PortalRoot>
  ) : null;

  function getTargetProps() {
    return {
      className: getTargetClass(),
      style: { transform: `translateY(${yOffset}px)` },
    };
  }
  function getClass() {
    return classNames({
      [styles.anchorFixed]: fixed,
      [styles.anchorStatic]: !fixed,
    });
  }

  function getTargetClass() {
    return classNames(
      {
        [styles.center]: location === "center",
        [styles.fullScreen]: location === "full-screen",
        [styles.hidden]: location === "hidden",
      },
      styles.target,
      overlayClassName
    );
  }
};

export const centerToWindowPropTypes = {
  /** Target content to be placed in the center of the viewport. */
  children: PropTypes.node.isRequired,

  /** Indicates if centered content will scroll with the window. */
  fixed: PropTypes.bool,

  /** Which adjacent side to render target relative to anchor. */
  location: PropTypes.oneOf(["center", "full-screen", "hidden"]),

  /** Additional classes to wrap the overlay element (children). */
  overlayClassName: PropTypes.string,
};
CenterToWindow.propTypes = centerToWindowPropTypes;
